import { forwardRef, PropsWithChildren, Ref } from 'react';

import { Icon as IconContainer } from '@mui/material';

import { BaseProps } from '../types';

const Icon = forwardRef(({ className, ...props }: PropsWithChildren<BaseProps>, ref: Ref<HTMLSpanElement>) => (
  <IconContainer component="span" {...props} ref={ref} sx={{ fontSize: '18px', verticalAlign: 'text-bottom' }} className={className} />
));

export default Icon;
